///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const Spinner = ({
  className,
  height,
  fill,
  title = messages.spinner.defaultMessage,
  width,
  style
}) => (
  <svg
    aria-labelledby="spinner-icon"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <title id="spinner-icon">{title}</title>
    <path fill={fill} d="M8 0a8 8 0 11-8 8h1.6A6.4 6.4 0 108 1.6V0z" />
  </svg>
);

export default Spinner;
